'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const universal_color = require('../../../style/universal.color.js');
const icon = require('../../Icon/icon.js');
const table_types = require('../table.types.js');
const tableCell_style = require('./table-cell.style.js');
const dataTable_types = require('../../DataTable/dataTable.types.js');

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var mlbWhite = universal_color.mlbWhite,
    mlbGrey3 = universal_color.mlbGrey3,
    mlbGrey4 = universal_color.mlbGrey4,
    mlbBlack = universal_color.mlbBlack;

var determineIndicatorFill = function determineIndicatorFill(dark, active) {
  return active ? dark ? mlbWhite : mlbBlack : dark ? mlbGrey3 : mlbGrey4;
};

var buildSortIndicator = function buildSortIndicator(direction, isSelected, dark) {
  var isDescending = direction === dataTable_types.SortOrderTypes.DESC;
  return /*#__PURE__*/React__default.createElement(tableCell_style.SortIndicator, {
    isDescending: isDescending,
    isSelected: isSelected
  }, /*#__PURE__*/React__default.createElement(icon, {
    name: "caret-up",
    fill: determineIndicatorFill(dark, !isDescending)
  }), /*#__PURE__*/React__default.createElement(icon, {
    name: "caret-down",
    fill: determineIndicatorFill(dark, isDescending)
  }));
};

var TableCell = function TableCell(props) {
  var _props$alignment = props.alignment,
      alignment = _props$alignment === void 0 ? table_types.Alignments.CENTER : _props$alignment,
      content = props.content,
      cellType = props.cellType,
      tableIndex = props.tableIndex,
      columnIndex = props.columnIndex,
      rowIndex = props.rowIndex,
      _props$firstColPinned = props.firstColPinned,
      firstColPinned = _props$firstColPinned === void 0 ? false : _props$firstColPinned,
      _props$lastColPinned = props.lastColPinned,
      lastColPinned = _props$lastColPinned === void 0 ? false : _props$lastColPinned,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
      colgroupStart = props.colgroupStart,
      colgroupEnd = props.colgroupEnd,
      colgroupSpan = props.colgroupSpan,
      _props$lastColumn = props.lastColumn,
      lastColumn = _props$lastColumn === void 0 ? false : _props$lastColumn,
      _props$firstRow = props.firstRow,
      firstRow = _props$firstRow === void 0 ? false : _props$firstRow,
      _props$lastRow = props.lastRow,
      lastRow = _props$lastRow === void 0 ? false : _props$lastRow,
      firstGroupStart = props.firstGroupStart,
      cellHighlighted = props.cellHighlighted,
      columnHighlighted = props.columnHighlighted,
      _props$highlightHead = props.highlightHead,
      highlightHead = _props$highlightHead === void 0 ? true : _props$highlightHead,
      fixedWidth = props.fixedWidth,
      dark = props.dark,
      _props$handlers = props.handlers,
      handlers = _props$handlers === void 0 ? {} : _props$handlers,
      columnSortIndex = props.columnSortIndex,
      sortState = props.sortState,
      sortable = props.sortable,
      highlightSortedColumn = props.highlightSortedColumn,
      highlightColor = props.highlightColor;
  var cell; // Set aria info

  var ariaColSpan = colgroupSpan ? 'colgroup' : 'col';
  var ariaIdHeaderCol = "tb-".concat(tableIndex, "-header col-").concat(columnIndex);
  var ariaIdBodyRow = "tb-".concat(tableIndex, "-body row-").concat(rowIndex, " col-").concat(columnIndex); // descover if we're in the head or not

  var inHead = cellType === table_types.CellTypes.SUPER_HEADER || cellType === table_types.CellTypes.HEADER;
  var normalHeader = cellType === table_types.CellTypes.HEADER;
  var isSelected = cellType !== table_types.CellTypes.SUPER_HEADER && columnSortIndex === columnIndex; // IF we are, or are pinned, build as a th element

  if (inHead || firstColPinned || lastColPinned) {
    var isReactElement = /*#__PURE__*/React__default.isValidElement(content);
    var cellContent = isReactElement ? content : /*#__PURE__*/React__default.createElement("span", null, content);
    var sortIndicator = buildSortIndicator(sortState, isSelected, dark);
    var headHandlers = sortable ? handlers : {};
    cell = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(tableCell_style.StyledTableHead, _extends({
      alignment: alignment,
      fixedWidth: fixedWidth,
      firstColPinned: firstColPinned,
      lastColPinned: lastColPinned,
      inHead: inHead,
      dark: dark,
      scope: ariaColSpan,
      colSpan: colgroupSpan,
      headers: ariaIdHeaderCol,
      columnHighlighted: highlightHead && highlightSortedColumn && (columnHighlighted || isSelected),
      normalHeader: normalHeader,
      "data-col": columnIndex,
      tabIndex: sortable ? '0' : undefined,
      sortable: sortable,
      highlightColor: highlightColor
    }, headHandlers), sortable && sortIndicator, cellContent));
  } else {
    var tdProps = {
      'data-col': columnIndex,
      'data-row': rowIndex,
      key: "".concat(cellType, "-").concat(rowIndex, "-").concat(columnIndex)
    };

    var _isReactElement = /*#__PURE__*/React__default.isValidElement(content);

    var useplaceholder = typeof content === 'undefined';
    var cellText = useplaceholder ? placeholder : content;

    var _cellContent = _isReactElement ? content : /*#__PURE__*/React__default.createElement("span", null, cellText);

    var ariaHeaderSource = firstColPinned || lastColPinned ? ariaIdBodyRow : undefined;
    var notPinnedCol = true;
    cell = /*#__PURE__*/React__default.createElement(tableCell_style.StyledTableCell, _extends({
      colgroupStart: colgroupStart,
      colgroupEnd: colgroupEnd,
      alignment: alignment,
      fixedWidth: fixedWidth,
      colIndex: columnIndex,
      lastColumn: lastColumn,
      firstRow: firstRow,
      lastRow: lastRow,
      firstGroupStart: firstGroupStart,
      dark: dark,
      scope: "row",
      headers: ariaHeaderSource,
      id: notPinnedCol ? ariaIdBodyRow : undefined,
      columnHighlighted: highlightSortedColumn && (columnHighlighted || isSelected),
      cellHighlighted: cellHighlighted,
      highlightHead: highlightHead,
      highlightColor: highlightColor
    }, tdProps), _cellContent);
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, cell);
};

module.exports = TableCell;
